import { Archivo, Tinos, Wix_Madefor_Text, Wix_Madefor_Display } from 'next/font/google';

// Brand fonts, self-hosted by next/font (no external CDN / CSP concerns under
// manage.wix.com), exposed as CSS variables. Wix Madefor is the shared app
// typeface: Text for body/UI, Display for headings. Archivo + Tinos are
// Symphony-only display/serif faces.
//
// FONT_VARS must be applied to <html> (see pages/_document.tsx) — NOT a wrapper
// inside <body>. The brand tokens (`--brand-font-display`, `--brand-font-ui`)
// are declared on `:root` / `[data-brand]` (html), and a custom property
// resolves where it's declared: if `--font-archivo` lives on a div inside body,
// `--brand-font-display: var(--font-archivo)` computes to empty at html and the
// whole app silently falls back to the system sans.
// Archivo (Symphony's display face): DESKTOP ships at Medium (500) — reduced from SemiBold — so
// headings read a touch lighter. MOBILE keeps the prior SemiBold (600) look (the redefinition is
// desktop-only — see the mobile weight-restore block in globals.css), so 600 is still loaded; 700
// stays for the rare bold.
const fontDisplay = Archivo({ subsets: ['latin'], weight: ['500', '600', '700'], variable: '--font-archivo', display: 'swap' });
// Wix Madefor is a VARIABLE font — load the weight axis (no static cuts) so the design
// system's redefined weights render precisely: Medium is 460 and SemiBold 560, not the
// 500/600 static instances (see `design-tokens/Typography.tokens.json` + `--sym-weight-*`).
const fontUi = Wix_Madefor_Text({ subsets: ['latin'], variable: '--font-madefor', display: 'swap' });
const fontHeading = Wix_Madefor_Display({ subsets: ['latin'], variable: '--font-madefor-display', display: 'swap' });
const fontSerif = Tinos({ subsets: ['latin'], weight: ['400', '700'], variable: '--font-tinos', display: 'swap' });

export const FONT_VARS = `${fontDisplay.variable} ${fontUi.variable} ${fontHeading.variable} ${fontSerif.variable}`;
